import cx from "classnames"
import { cloneElement, isValidElement } from "react"
import type { ButtonProps } from "../Buttons/Button/type"

export type CalloutPropsType = React.PropsWithChildren<{
  title?: string
  cta?: React.ReactNode
  illustrationUrl?: string
  variant: "warning" | "neutral" | "error"
  className?: string
}>

function enforceCTA(
  cta: React.ReactNode,
  variant: CalloutPropsType["variant"],
) {
  if (!cta || !isValidElement<ButtonProps>(cta)) {
    return cta
  }

  return variant === "error"
    ? cloneElement(cta, {
        size: "small",
        primary: true,
        destructive: true,
      })
    : cloneElement(cta, {
        size: "small",
        variant,
      })
}

export const Callout = ({
  title,
  children,
  cta,
  variant = "neutral",
  illustrationUrl,
  className,
}: CalloutPropsType) => {
  // force CTA to match Callout variant
  const enforcedCTA = enforceCTA(cta, variant)

  return (
    <div
      className={cx(
        "cobalt-callout",
        {
          "cobalt-callout--warning": variant === "warning",
          "cobalt-callout--neutral": variant === "neutral",
          "cobalt-callout--error": variant === "error",
        },
        className,
      )}
    >
      <div className="cobalt-callout__content">
        {title && <div className="cobalt-callout__title">{title}</div>}
        <div className="cobalt-callout__body">{children}</div>
        {enforcedCTA}
      </div>
      {illustrationUrl && (
        <img
          alt={title ?? ""}
          className="cobalt-callout__illustration"
          src={illustrationUrl}
        />
      )}
    </div>
  )
}

export default Callout
